import { render, staticRenderFns } from "./_pepin.vue?vue&type=template&id=834fa856&lang=pug&"
import script from "./_pepin.vue?vue&type=script&lang=js&"
export * from "./_pepin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports